import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const EditPotType = ({ show, onClose, leadstatusIdToEdit, refresh }) => {
    const [leadstatus_name, setname] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');
    const [existingLeadstatus, setExistingLeadstatus] = useState([]);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [backgroundColor, setBackgroundColor] = useState('#000000');
    const [textColor, setTextColor] = useState('#ffffff');
    // const [colorChange] = useState(null);

    const formatleadsourceName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    useEffect(() => {
        if (show && leadstatusIdToEdit) {
            axios.get(`${baseURL}/leadstatus/${leadstatusIdToEdit}`)
                .then(response => {
                    console.log("Fetched leadstatus:", response.data);
                    console.log("Fetched leadstatus:", response.data);
                    const leadstatus = response.data.data;
                    setname(leadstatus.leadstatus_name);
                    setDescription(leadstatus.description || '');
                    setBackgroundColor(leadstatus.background_color || '#000000');
                    setTextColor(leadstatus.text_color || '#ffffff');
                })
                .catch(error => {
                    console.error("Error fetching leadstatus", error);
                });

                axios.get(`${baseURL}/leadstatus`)
                .then(response => {
                    setExistingLeadstatus(
                        response.data.data.data
                            .filter(c => c.sno !== leadstatusIdToEdit) // exclude current one
                            .map(leadstatus => leadstatus.leadstatus_name.toLowerCase())
                    );
                })
                .catch(error => {
                    console.error("Error fetching countries", error);
                });
        }
    }, [show, leadstatusIdToEdit]);

    const validateInput = () => {
        // Check if the lead status name is empty
        if (!leadstatus_name.trim()) {
            setError("Leadstatus is required.");
            return false;
        }
        
        const regex = /^[A-Za-z\s]+$/;
        if (!regex.test(leadstatus_name)) {
            setError("Only text is valid.");
            return false;
        }
        
        const formattedleadstatusName = leadstatus_name.trim().toLowerCase();
        // Check if the leadstatus already exists
        if (existingLeadstatus.includes(leadstatus_name.trim().toLowerCase())) {
            setError("Leadstatus already exists.");
            return false;
        }

        setError('');
        return true;
    };

    const handleUpdate = (e) => {
        e.preventDefault();

        const formattedleadstatusName = formatleadsourceName(leadstatus_name);

        if (!validateInput()) return;

        axios.put(`${baseURL}/leadstatus/${leadstatusIdToEdit}`, {
            leadstatus_name,
            description: description.trim() || '-',
            background_color: backgroundColor,
            text_color: textColor
        })
            .then(response => {
                refresh();
                onClose();
                toast.success("Lead Status Updated successfully!");
                // window.location.reload(); // optional, can use state update instead
            })
            .catch(error => {
                console.error("Error updating Lead status", error);
                setError("An error occurred while updating the Lead status.");
            });
    };


    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Lead Status</h3>
                    <Button variant="" type="button" className="close px-6 py-1" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                <form onSubmit={handleUpdate}>
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Lead Status<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Lead Status" value={leadstatus_name}
                            onChange={(e) => setname(formatleadsourceName(e.target.value))}/>
                            {error && <small className="text-danger">{error}</small>}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Background Color<span className="required">*</span></label>
                            <input type="color" className="form-control"  placeholder="Choose Background Color" value={backgroundColor}
                            onChange={(e) => setBackgroundColor(e.target.value)}/>
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Text Color<span className="required">*</span></label>
                            <input type="color" className="form-control"  placeholder="Choose Text Color" value={textColor}
                            onChange={(e) => setTextColor(e.target.value)}/>
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={2} className="form-control h-auto" name="comment" placeholder="Description" value={description}
                            onChange={(e) => setDescription(e.target.value)} />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                        <button type="submit" className="btn btn-sm btn-primary" >Update Lead Status<i className="fas fa-angle-double-right ms-2"></i></button>
                    </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default EditPotType;
